/* eslint-disable no-underscore-dangle */

import 'react-app-polyfill/ie11';
import 'core-js';

import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Buffer } from 'buffer';

import { setServerSideRenderingState } from 'jss-boilerplate/RouteHandler';
import { enableDebug } from '@sitecore-jss/sitecore-jss-react';
import AppRoot from 'jss-boilerplate/AppRoot';

window.Buffer = Buffer;

if (typeof process !== 'undefined' && process.env.REACT_APP_DEBUG) {
  enableDebug(process.env.REACT_APP_DEBUG);
}

let renderFunction = (rootElement, component) => {
  const root = createRoot(rootElement);
  root.render(component);
};

/*
  SSR Data
  If we're running in a server-side rendering scenario,
  the server will provide JSON in the #__JSS_STATE__ element
  for us to acquire the initial state to run with on the client.

  This enables us to skip a network request to load up the layout data.
  We are emitting a quiescent script with JSON so that we can take advantage
  of JSON.parse()'s speed advantage over parsing full JS, and enable
  working without needing `unsafe-inline` in Content Security Policies.

  SSR is initiated from /server/server.js.
*/
let __JSS_STATE__ = null;
const ssrRawJson = document.getElementById('__JSS_STATE__');
if (ssrRawJson) {
  try {
    __JSS_STATE__ = JSON.parse(ssrRawJson.innerHTML);
    // Debug log SSR state on the client
    // console.log('[SSR] Client-side state after parse:', __JSS_STATE__);
  } catch (err) {
    console.error('[SSR] Error parsing SSR state:', err, ssrRawJson.innerHTML);
  }
}
if (__JSS_STATE__) {
  setServerSideRenderingState(__JSS_STATE__);
  renderFunction = hydrateRoot;
}

/*
  App Rendering
*/
// HTML element to place the app into
const rootElement = document.getElementById('root');

renderFunction(
  rootElement,
  <AppRoot path={window.location.pathname} Router={BrowserRouter} ssrState={__JSS_STATE__} />

);

